import React, { useState } from 'react';
import deliveryService from '../../services/deliveryNoteService';
import customerReturnService from '../../services/customerReturnService';
import { remainingTicketLines } from '../../helpers/customerReturnTicket';

export default function ReturnTicketPicker({ onSelect, disabled, reference }) {
  const [query, setQuery] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const load = async () => {
    if (!query.trim() || busy) return;
    setBusy(true); setError('');
    try {
      const ticket = await deliveryService.findByReference(query.trim());
      if ((ticket.statut || ticket.status) !== 'LIVRE') throw new Error('Choisissez un ticket ou BL livré.');
      const response = await customerReturnService.linked([ticket.numero]);
      const lines = remainingTicketLines(ticket, response.data[ticket.numero] || []);
      if (!lines.length) throw new Error('Tous les articles ont déjà été retournés.');
      onSelect(ticket, lines);
    } catch (e) { setError(e.response?.data?.message || e.message || 'Ticket introuvable.'); }
    finally { setBusy(false); }
  };
  return <div className="border rounded p-3 mb-3 bg-light">
    <label htmlFor="return-source-ticket" className="form-label fw-bold">1. Ticket ou bon de livraison d'origine (facultatif)</label>
    <div className="d-flex gap-2">
      <input id="return-source-ticket" className="form-control" placeholder="Scannez ou saisissez le numéro" value={query} disabled={disabled || busy}
        onChange={e => setQuery(e.target.value)} onKeyDown={e => { if(e.key === 'Enter') { e.preventDefault(); load(); } }} />
      <button type="button" className="btn btn-primary" disabled={disabled || busy || !query.trim()} onClick={load}>{busy ? 'Chargement...' : 'Charger'}</button>
    </div>
    {reference && <div className="text-success mt-2">Lié au ticket {reference}. Conservez uniquement les articles rapportés et ajustez les quantités.</div>}
    {error && <div className="text-danger mt-2" role="alert">{error}</div>}
    <small className="text-muted">Le ticket d'origine reste inchangé. Le retour sera affiché avec la vente.</small>
  </div>;
}
